import { combineReducers } from 'redux';

import duplicate from './duplicate';
import target from './target';
import unpublish from './unpublish';

/**
 * @typedef {{
 *   target: import('./target').AuditModelUIModalTargetReducer,
 *   duplicate: import('./duplicate').AuditModelUIModalDuplicateReducer,
 *   unpublish: import('./unpublish').AuditModelUIModalUnpublishReducer,
 * }} AuditModelUIModalReducer
 */

export default combineReducers({
  target,
  duplicate,
  unpublish,
});
